import { DEFAULT_LANGUAGE, supportedLanguages } from '@/i18next';

export function stripTrailingSlash(str) {
	if (str.substr(-1) === '/') {
		return str.substr(0, str.length - 1);
	}
	return str;
}

export function getPathLanguage() {
	const [, firstPart] = window.location.pathname.split('/');
	return supportedLanguages.includes(firstPart) ? firstPart : null;
}

export function hasPathLanguage(route) {
	const [, firstPart] = route.split('/');
	return supportedLanguages.includes(firstPart);
}

export function localizedRoute(route) {
	const urlLang = getPathLanguage();

	if (urlLang) {
		return stripTrailingSlash(`/${urlLang}${route}`);
	}

	return route;
}

export function getAbsolutePath(pathname) {
	const parts = pathname.split('/');
	if (parts.length < 2 || !hasPathLanguage(pathname)) {
		return pathname;
	}

	parts.splice(1, 1);

	return parts.join('/');
}

export function addLanguageToRoute(route, language) {
	const absolutePath = getAbsolutePath(route);

	if (language === DEFAULT_LANGUAGE) {
		return absolutePath;
	}

	return stripTrailingSlash(`/${language}${absolutePath}`);
}

export function addLanguageParam(route) {
	return `/:lang?${route}`;
}

export function mapSpecialLocales(base, reverse = false) {
	// Support of NO (Norwegian)

	if (!reverse) {
		if (base && base.toLowerCase() === 'no') {
			return 'nb';
		}
	} else if (base && base.toLowerCase() === 'nb') {
		return 'no';
	}

	return base;
}

export function getBrowserLocale() {
	const browserLocales =
		navigator.languages === undefined
			? [navigator.language]
			: navigator.languages;

	if (!browserLocales) return undefined;

	return browserLocales
		.map(locale => {
			const trimmedLocale = locale.trim().toLowerCase();
			const smallLocale = trimmedLocale.split(/-|_/)[0];

			return smallLocale;
		})
		.filter(locale => supportedLanguages.includes(locale))[0];
}
